// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"deaf9986","224":"06d98616","250":"2a1dbf09","407":"781749ad","436":"d4a9d75c","453":"f394a27d","455":"2b9dbaca","501":"2679d97b","595":"e0b45d8e","606":"178ba368","691":"2079e998","821":"99ad4e65","925":"791996e8","969":"b1685380"}[chunkId] + ".chunk.js";
};